import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import LiveClassTable from './LiveClassTable';
const LiveClass = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Live Class' parent='Live Class'  />
      <Container fluid={true}>
        <Row>
          <LiveClassTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default LiveClass;
